<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 100 6"
        preserveAspectRatio="none"
        fill="none"
        style="width: 100%; height: 6px; display: block; margin: 0; padding: 0">
        <path
            fill="#272360"
            d="M25.084 6H0V0h25.084v6Z" />
        <path
            fill="#F79138"
            d="M50 6H25.084V0h24.916v6Z" />
        <path
            fill="#8FAFDC"
            d="M62.458 6H50V0h12.458v6Z" />
        <path
            fill="#CBDEF2"
            d="M74.916 6h-12.458V0h12.458v6Z" />
        <path
            fill="#499158"
            d="M87.542 6h-12.626V0h12.626v6Z" />
        <path
            fill="#FEBF21"
            d="M100 6h-12.458V0h12.458v6Z" />
    </svg>
</template>
